import $ from 'jquery';
import Keyboard from './keyboard';

const VISUAL_NAV_JS = 'js-visual-nav';

const ATTRIBUTE_CLASS = 'visual-nav__attr';
const ATTRIBUTE_ITEM_CLASS = 'visual-nav__attr-item';
const ATTRIBUTE_LIST_BUTTON_CLASS = 'visual-nav__attr-list-button';
const ATTRIBUTE_BUTTON_CLASS = 'visual-nav__attr-button';
const ATTRIBUTE_ITEM_ACTIVE_CLASS = 'visual-nav__attr-item--active';
const ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS = 'visual-nav__attr-list-button--active';
const ATTRIBUTE_CONTAINERS_CLASS = 'visual-nav__attrs';
const ATTRIBUTE_BUTTON_SELECTED_CLASS = 'visual-nav__attr-button--selected';

const getAttributesId = attributeGroupName => `#visual-nav-attrs-${attributeGroupName}`;

const animateInAttributes = ($activeAttributeItems) => {
  const animationDelay = 80;

  $activeAttributeItems.each(function animationOfAttributes(i) {
    setTimeout(() => {
      $(this).addClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
    }, animationDelay * i);
  });
};

const showAttributesById = (id) => {
  $(`.${ATTRIBUTE_ITEM_ACTIVE_CLASS}`).removeClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
  const $activeAttributeContainer = $(id);
  const $activeAttributeItems = $activeAttributeContainer.find(`.${ATTRIBUTE_ITEM_CLASS}`);
  $(`.${ATTRIBUTE_CONTAINERS_CLASS}`).hide();
  $activeAttributeContainer.show();

  animateInAttributes($activeAttributeItems);
};

const highlightAttributeGroupItem = ($el) => {
  $(`.${ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS}`).removeClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
  $el.addClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
};

const scrollAllAttributesToLeft = () => {
  $(`.${ATTRIBUTE_CLASS}`).scrollLeft(0);
};

function updateUiFromAvailableLabels(availableLabels) {
  const $attributeButtons = $('.visual-nav__attr-button');
  const $attributeGroupButtons = $('.visual-nav__attr-list-button');

  // Update Attribute Buttons
  $attributeButtons.each((i, attributeEl) => {
    const $attribute = $(attributeEl);
    const attributeName = $attribute.data('attr');
    const isAvailable = availableLabels.includes(attributeName);

    if (isAvailable) {
      $attribute.attr('disabled', false);
    } else {
      $attribute.attr('disabled', true);
    }
  });

  function hasEnabledAttribute($attributes) {
    let result = false;

    $.each($attributes, (key, el) => {
      // console.log(key, $(el));
      if ($(el).attr('disabled') === undefined) {
        result = true;
        // This will only exit the anonymous function and
        // stop the iteration immediately.
        return false;
      }
      return true;
    });

    // This will exit the function with return true;
    return result;
  }

  // Update Attribute List Buttons
  $attributeGroupButtons.each((i, attributeGroupEl) => {
    const $attributeGroupButton = $(attributeGroupEl);
    const $attributesContainer = $(`#visual-nav-attrs-${$attributeGroupButton.data('name')}`);
    const $attributes = $attributesContainer.find('.visual-nav__attr-button');
    const enabled = hasEnabledAttribute($attributes);

    if (enabled) {
      $attributeGroupButton.attr('disabled', false);
    } else {
      $attributeGroupButton.attr('disabled', true);
    }
  });
}

/**
 * Renders the state of attr buttons based on the selected class
 * @param {jQuery} $attributeButtons - attr buttons of a particular filter.
 */
const renderStateAttributeButtons = ($attributeButtons) => {
  $attributeButtons.each(function renderStateAttributeButton() {
    const $attributeButton = $(this);
    const isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);

    if (isAttributeSelected === true) {
      const imgSelected = $attributeButton.data('img-selected');
      $attributeButton.find('img').attr('src', imgSelected);
    } else {
      const img = $attributeButton.data('img');
      $attributeButton.find('img').attr('src', img);
    }
  });
};

const updateAttributeListCounter = ($attributeButton) => {
  const $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  const attributeGroupButtonId = $attributeContainer.attr('id');
  const attributeSelected = $attributeContainer.find(`.${ATTRIBUTE_BUTTON_SELECTED_CLASS}`);
  const attributeSelectedCount = attributeSelected.length;
  const $attributeGroupButton = $(`[aria-controls="${attributeGroupButtonId}"]`);
  const $attributeGroupTextContainer = $attributeGroupButton.find('.visual-nav__attr-list-text');
  const $counter = $attributeGroupTextContainer.find('.visual-nav__attr-list-counter');

  if (attributeSelectedCount === 0) {
    $counter.remove();
    return;
  }

  if ($counter.length === 0) {
    $attributeGroupTextContainer.append(`<span class="visual-nav__attr-list-counter">(${attributeSelectedCount})</span>`);
  } else {
    $counter.text(`(${attributeSelectedCount})`);
  }
};

/**
 * Reset Aria Attributes
 * @param  {jQuery} $listButtons - the top level list buttons
 */
const resetAriaAttributes = ($listButtons) => {
  $listButtons.each((key, listButton) => {
    const $listButton = $(listButton);
    $listButton.attr('aria-expanded', false);
    $listButton.attr('aria-selected', false);
  });
};

/**
 * Sets Aria Attributes for newly selected list button
 * @param  {jQuery} $selectedButton - selected list button
 */
const setAriaAttributes = ($selectedButton) => {
  $selectedButton.attr('aria-expanded', true);
  $selectedButton.attr('aria-selected', true);
};

/**
 * Arrow Handler
 * @param  {string} direction - direction of focus, next or previous el
 * @param  {jQuery} $focusedEl - el currently in focus
 * @param  {jQuery} $siblings - list of focusable elements
 */
const arrowHandler = (direction, $focusedEl, $siblings) => {
  const currentIndex = $siblings.index($focusedEl);
  let targetIndex;
  // hit right arrow on the last element, focus goes to the first in the list
  if (currentIndex === $siblings.length - 1 && direction === 'next') {
    targetIndex = 0;
  // hit left arrow on the first element, focus goes to the last in the list
  } else if (currentIndex === 0 && direction === 'prev') {
    targetIndex = $siblings.length - 1;
  } else {
    targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  }
  $siblings[targetIndex].focus();
};

/**
 * Keydown Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $visualNav - visual nav module
 */
const handleKeydown = (evt, $visualNav) => {
  const $currentFocusedEl = $visualNav.find(':focus');
  const isGroupButton = $currentFocusedEl.hasClass(ATTRIBUTE_LIST_BUTTON_CLASS);
  const isEscape = Keyboard.parseKey(evt) === Keyboard.keys.ESCAPE;
  const isNextArrows = Keyboard.parseKey(evt) === 'ARROWRIGHT' || Keyboard.parseKey(evt) === 'ARROWDOWN';
  const isPrevArrows = Keyboard.parseKey(evt) === 'ARROWLEFT' || Keyboard.parseKey(evt) === 'ARROWUP';

  // Group Item keyboard listeners
  if (isGroupButton) {
    const $groupButtons = $visualNav.find(`.${ATTRIBUTE_LIST_BUTTON_CLASS}`);
    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $groupButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $groupButtons);
    }
  }

  // Attribute keyboard listeners
  if (!isGroupButton) {
    const $attributeButtons = $visualNav.find(`.${ATTRIBUTE_ITEM_ACTIVE_CLASS} .${ATTRIBUTE_BUTTON_CLASS}`);
    if (isEscape) {
      // use data-parent-hash to move focus to parent list button
      const parentID = $currentFocusedEl.data('parent-hash');
      const $parentListItem = $visualNav.find(`[aria-controls="visual-nav-attrs-${parentID}"]`);
      $parentListItem.focus();
    }

    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $attributeButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $attributeButtons);
    }
  }
};

const findFirstFocusableAttribute = ($listButton, $visualNav) => {
  const controlValue = $listButton.attr('aria-controls');
  const $targetPanel = $visualNav.find(`#${controlValue}`);
  const $targetAttribute = Keyboard.findFocusable($targetPanel).eq(0);
  $targetAttribute.focus();
};

const handleAttributeClick = ($attributeButton, doSearch) => {
  const $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  const selectedBehavior = $attributeContainer.data('select-behavior');
  const $attributeButtons = $attributeContainer.find('.visual-nav__attr-button');
  const isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);

  if (selectedBehavior === 'single') {
    // Remove selected state from all attr buttons
    $attributeButtons.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  }

  // Toggle class of clicked attr button
  if (isAttributeSelected) {
    $attributeButton.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  } else {
    $attributeButton.addClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  }

  renderStateAttributeButtons($attributeButtons);
  updateAttributeListCounter($attributeButton);
  if (doSearch) {
    window.doVisualSearch(1);
  }
};

const lazyLoadImagesById = function lazyLoadImagesById(id) {
  const images = $(id).find('[data-vn-lazy]');
  $.each(images, (index, image) => {
    const $image = $(image);
    $image.attr('src', $image.data('vn-lazy'));
    $image.removeAttr('data-vn-lazy');
  });
};

const handleAttributeGroupClick = function handleAttributeGroupClick($el) {
  const attributeGroupName = $el.data('name');
  const id = getAttributesId(attributeGroupName);

  highlightAttributeGroupItem($el);
  showAttributesById(id);
  scrollAllAttributesToLeft();
  lazyLoadImagesById(id);
};

const addEventsToAttributeGroupButtons = ($attributeGroupButtons, $visualNav) => {
  $attributeGroupButtons.on('click', function attributeGroupButtonsHandleClick() {
    handleAttributeGroupClick($(this));
    resetAriaAttributes($attributeGroupButtons);
    setAriaAttributes($(this));
    findFirstFocusableAttribute($(this), $visualNav);
  });
};

const addEventsToAttributeButtons = ($visualNav) => {
  $visualNav.on('click', `.${ATTRIBUTE_BUTTON_CLASS}`, function attributeButtonHandleClick() { handleAttributeClick($(this), true); });
};

function init() {
  const $visualNav = $(`.${VISUAL_NAV_JS}`);
  const $attributeGroupButtons = $visualNav.find(`.${ATTRIBUTE_LIST_BUTTON_CLASS}`);
  handleAttributeGroupClick($attributeGroupButtons.first());
  addEventsToAttributeGroupButtons($attributeGroupButtons, $visualNav);
  addEventsToAttributeButtons($visualNav);
  $visualNav.on('keydown.visualnav', (evt) => {
    handleKeydown(evt, $visualNav);
  });
}

init();

window.visualNav = {
  updateUiFromAvailableLabels,
  handleAttributeClick,
  handleAttributeGroupClick,
};



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/visual-nav.js